/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/label-has-associated-control */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, func,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { setTwillioMessageChatBot } from '../../../../../state/ducks/App/App-Actions';

const styles = (theme)  => ({
    searchBar: {
        maxWidth: '44%',
        margin: '30px auto;',
        [theme.breakpoints.down('md')]: {
            maxWidth: '50%',
            margin: '20px auto;',
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '98%',
        },
    },
    searchContainer: {
        width: '100%',
        border: `1px solid ${theme.palette.buttonBackgroundColor || '#333'}`,
        borderRadius: '30px',
        position: 'relative',
        padding: 10,
        '& label': {
            display: 'flex',
        },
        '& input': {
            width: '100%',
            border: 'none',
            '&:focus': {
                border: 'none',
                outline: 'none',
            },
        },
        '& .MuiButton-root': {
            borderRadius: 23,
            fontSize: 14,
            '&:hover': {
                backgroundColor: theme.palette.secondary?.main || '#00C876',
                color: theme.palette.common?.white || '#ffffff',
            },
        },
    },
    letsGo: {
        top: 2,
        right: 3,
        position: 'absolute',
        backgroundColor: theme.palette.secondary?.main || '#00C876',
        color: theme.palette.common?.white || '#ffffff',
        borderRadius: '23px',
        fontSize: '14px',
        padding: 10,
        '&:hover': {
            backgroundColor: theme.palette.secondary?.main || '#00C876',
            color: theme.palette.common?.white || '#ffffff',
        },
    },
});

const TwilloSearchBar = ({ classes, trackEvent, isMessageUpdate }) => {
    const [searchItem, setValue] = React.useState('');
    const handleChange = (e) => {
        setValue(e?.target?.value);
    };
    const setValueInLocalStorage = () => {
        if (searchItem && typeof window !== 'undefined' && typeof document !== 'undefined') {
            localStorage.setItem('smartHelpSearch', searchItem);
            isMessageUpdate(true);
            if (document.getElementById('livechat')) {
                document.getElementById('livechat').click();
                trackEvent({
                    eventCategory: 'customer-service',
                    eventAction: 'search-bar',
                    eventLabel: '',
                });
            }
        }
    };

    return  (
        <>
            <Grid container className={classes.searchBar}>
                <div className={classes.searchContainer}>
                    <label
                        className={classes.searchFormLabel}
                        htmlFor="SearchBox"
                    >
                        <SearchIcon />
                        <input
                            id="twillosearch"
                            type="text"
                            placeholder="Tell us how we can help."
                            value={searchItem}
                            onChange={(e) => handleChange(e)}
                            onKeyPress={(e) => e.key === 'Enter' && setValueInLocalStorage()}
                        />
                    </label>
                    <Button className={classes.letsGo} onClick={setValueInLocalStorage}>
                        let&#39;s go
                    </Button>
                </div>
            </Grid>
        </>
    );
};

TwilloSearchBar.propTypes = {
    classes: object.isRequired,
    trackEvent: func.isRequired,
    isMessageUpdate: func.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
    isMessageUpdate: bindActionCreators(setTwillioMessageChatBot, dispatch),
});
export default connect(null, mapDispatchToProps)(withStyles(styles)(TwilloSearchBar));
